import { 
    ALL_APPLY_TAB_ACTIVE,
    ALL_APPLY_LIST,
    ALL_APPLY_MORE_INITIAL,
    ALL_APPLY_MORE_FAILURE,
    ALL_APPLY_SEARCH_FIELD,
    ALL_APPLY_LIST_DETAILS,
    ALL_APPLY_BACKUP_ITEM
} from "Actions/allApply";
import update from 'immutability-helper';

const initialState = {
};
let payload = {}

export function allApply(state = initialState, action) {   
    switch (action.type) {
        case ALL_APPLY_TAB_ACTIVE:
            return update(state, { tabActive: action.payload });
        case ALL_APPLY_LIST:  
        if(action.payload.pageNum === 1) payload.allApplyList = action.payload.data;
        if(action.payload.pageNum > 1) {
            payload.allApplyList = state.allApplyList.concat(action.payload.data);
        }
        return { ...state, ...payload }; 
        case ALL_APPLY_MORE_INITIAL:
        case ALL_APPLY_MORE_FAILURE:
        // case ALL_APPLY_BACKUP_ITEM:
            return {
                ...state,
                ...action.payload
            }
        case ALL_APPLY_SEARCH_FIELD:
            return update(state, { searchfields: action.payload });
        case ALL_APPLY_LIST_DETAILS:
            payload.allApplyDetailsList = action.payload
            return { ...state, ...payload }; 
        default:
            return state;
    }
}
